import CardDetailsLanding from "./CardDetailsLanding";
import "../../styles/CardDetails.css";
import { Container } from "react-bootstrap";
import CareerInfo from "./CareerInfo";
import Popup from "./Popup";
import { useParams } from "react-router-dom";
import { useGetCareerByIdQuery } from "../../redux/features/careers/careersApiSlice";

function CardDetails() {
   // ################### ROUTER HOOKS ###################
   let { careerIDinfo } = useParams();

   // ################### RTK QUERY ###################
   const { data: career } = useGetCareerByIdQuery(careerIDinfo);

   return (
      <div className="card-details">
         <CardDetailsLanding name={career?.data?.name} />
         <div className="apply-now">
            <Container>
               <div className="rows">
                  <CareerInfo career={career?.data} />
                  <Popup />
               </div>
            </Container>
         </div>
      </div>
   );
}

export default CardDetails;
